import { Node } from 'slate';
import { ReactEditor } from 'slate-react';

export default function isNodeTextEqualToWindowSelection(editor) {
  return function (node: Node) {
    // @ts-ignore
    const windowSelectionText = window.getSelection()?.baseNode?.textContent;
    try {
      const domNode = node && ReactEditor.toDOMNode(editor, node);
      return domNode.textContent === windowSelectionText;
    } catch {
      // @ts-ignore
      return node?.text === windowSelectionText;
    }
  };
}
